@if (showPopup && bannerData) {
  <div class="popup-overlay">
    <a
      class="popup-banner"
      [ngStyle]="{
        'background-image': 'url(' + bannerData.mediabank?.url + ')'
      }"
      [href]="bannerData.link"
      target="_blank"
      rel="noopener"
    >
      <button class="popup-close" (click)="closePopup($event)">×</button>

      <div class="popup-wrapper">
        <div class="popup-content">
          <h3 class="popup-top-text">
            {{ bannerData.subHeading || 'Exclusive Offer' }}
          </h3>
          <h1 class="popup-title">{{ bannerData.title }}</h1>
        </div>
      </div>
    </a>
  </div>
}
